var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"model-widget",class:{ 
    'active': _vm.$store.state.editor.subId === _setup.modelId, 
    'disabled': !_vm.$store.state.editor.editMode 
  },on:{"click":_setup.handleSelect}},[_c('div',{staticClass:"widget-tag"},[_c('span',{staticClass:"tag-text"},[_vm._v(_vm._s(_vm.$t(`model.${_setup.menuInfo.title}`)))])]),_vm._v(" "),_c('div',{staticClass:"border-effect"}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }